import { loadLoginCurrent, PltUser } from "@szgc/plt-core-v2";
import { KgInstallOptions } from "../../types";

class Config {
  private _HTML5Url: KgInstallOptions["HTML5Url"] = "";
  convert: (current: PltUser) => Promise<string> = async (current) => {
    return current.username;
  };

  get HTML5Url() {
    return this._HTML5Url;
  }

  set HTML5Url(HTML5Url: string) {
    this._HTML5Url = HTML5Url;
  }

  get kgAssetUrl() {
    return location.origin + "/process-public-resouce/kinggrid";
  }
}

class Kinggrid {
  private loaded: boolean = true;

  config = new Config();

  /**
   * 签章用户序列号
   * @description 1、如果配置有客户端软件，并插有实体key或者配置有虚拟key，则使用客户端签获取到的keysn
   * @description 2、如果条件1不成立，使用平台账号作为keysn
   */
  private keysn!: string;

  /**
   * 签章方式
   * @description local 本地客户端签
   * @description server 服务端签
   */
  private client!: "local" | "server";

  /**
   * 客户端签能获取到的数据
   */
  private local!: any;

  async init(documentId: string, documentName: string, delCallBack: any) {
    const { success } = await this.getLocalClientInfo();
    if (success) {
      console.log("进行客户端初始化方案");
      this.initWithLocal(documentId, documentName, delCallBack);
    } else {
      console.log("进行服务端初始化方案");
      const { success: usuccess, data: current } = await this.getPltUserInfo();
      const keysn = await this.config.convert(current);
      console.log("当前用户信息：");
      console.log(current);
      console.log("当前用户keysn：");
      console.log(keysn);

      this.keysn = keysn;
      if (usuccess) {
        return await this.initWithServer(documentId, documentName, delCallBack);
      } else {
        return false;
      }
    }
  }

  initWithServer(documentId: string, documentName: string, delCallBack: any): Promise<boolean> {
    return new Promise((resolve) => {
      Signature.init({
        //初始化属性
        keysn: this.keysn,
        certType: "server", //设置证书在签章服务器
        sealType: "server", //设置印章从签章服务器取
        serverUrl: this.config.HTML5Url + "/html5",
        documentid: documentId, //设置文档ID
        documentname: documentName, //设置文档名称
        languagesPath: this.config.kgAssetUrl + "/languages",
        LANGUAGE: "zh_CN", //语言设置
        errorCall: (e: any) => {
          console.log("服务端签章初始化失败, => keysn=" + this.keysn);
          console.log(e);
          resolve(false);
        },
        okCall: () => {
          console.log(
            "服务端签章初始化成功, documentId = " +
              documentId +
              ", documentName = " +
              documentName +
              "，keysn = " +
              this.keysn
          );
          resolve(true);
        },
        delCallBack: delCallBack,
        pw_timeout: "s1800", //s：秒；h:小时；d:天
        showProtectedBtn: true //设置是否显示保护项按钮
      });
      Signature.list = [];
    });
  }

  async initWithLocal(
    documentId: string,
    documentName: string,
    delCallBack: any
  ): Promise<boolean> {
    return new Promise((resolve) => {
      Signature.init({
        //初始化属性
        clientConfig: {
          //初始化客户端参数
          LANGUAGE: "zh_CN", //zh_CN 中文 en_US 英文 zh_TW 中文繁体
          SOFTTYPE: "1" //0为：标准版， 1：网络版
        },
        clientCode: "",
        languagesPath: this.config.kgAssetUrl + "/languages",
        certType: "server", //设置证书在签章服务器
        sealType: "client", //设置印章从签章服务器取
        serverUrl: this.config.HTML5Url + "/html5",
        documentid: "KG2016093002", //设置文档ID
        documentname: "测试文档KG2016093001", //设置文档名称
        LANGUAGE: "zh_CN", //语言设置
        errorCall: (e: any) => {
          console.log("客户端签章初始化失败, => keysn=" + this.keysn);
          console.log(e);
          resolve(false);
        },
        okCall: () => {
          console.log(
            "客户端签章初始化成功, documentId = " +
              documentId +
              ", documentName = " +
              documentName +
              "，keysn = " +
              this.keysn
          );
          resolve(true);
        },
        delCallBack: delCallBack,
        pw_timeout: "s1800", //s：秒；h:小时；d:天
        showProtectedBtn: true //设置是否显示保护项按钮
      });
    });
  }

  getPltUserInfo(): Promise<{ success: boolean; data: any }> {
    return new Promise((resolve) => {
      loadLoginCurrent()
        .then((res) => {
          if (res.success) {
            const current = res.data as PltUser;
            resolve({
              success: true,
              data: current
            });
          } else {
            resolve({ success: false, data: {} as PltUser });
          }
        })
        .catch(() => {
          resolve({ success: false, data: {} as PltUser });
        });
    });
  }

  /**
   * 获取本地客户端信息
   * @returns
   */
  getLocalClientInfo(): Promise<{ success: boolean; data: any }> {
    return new Promise((resolve) => {
      console.log("尝试通过本地客户端读取签章用户信息");
      Signature.AXI("KGGetKeyInfo", "0")
        .then((callback: any, data: any) => {
          if (data.result) {
            console.log("读取成功", data);
            this.keysn = data.keysn;
            this.local = data;
            this.client = "local";
            resolve({ success: true, data: data });
          } else {
            this.keysn = "";
            this.local = null;
            this.client = "server";
            console.log("读取失败");
            resolve({ success: false, data: null });
          }
        })
        .fail((fn: any) => {
          console.log("本地客户端驱动未找到");
          resolve({ success: false, data: null });
          fn(false);
        });
    });
  }
}

const kinggrid = new Kinggrid();
export default kinggrid;

function loadJs(src: string): Promise<boolean> {
  return new Promise((resolve) => {
    const tag = document.createElement("script");
    tag.src = src;
    tag.type = "text/javascript";
    tag.onload = function () {
      resolve(true);
    };
    tag.onerror = function () {
      resolve(false);
    };
    document.head.appendChild(tag);
  });
}

function loadCss(src: string): Promise<boolean> {
  return new Promise((resolve) => {
    const tag = document.createElement("link");
    tag.href = src;
    tag.rel = "stylesheet";
    tag.charset = "utf-8";
    tag.type = "text/css";
    tag.onload = function () {
      resolve(true);
    };
    tag.onerror = function () {
      resolve(false);
    };
    document.head.appendChild(tag);
  });
}

/**
 * 如果需要使用金格签章，需要在入口文件中调用Vue.use，并将此方法作为install方法进行调用
 */
async function _install_kinggrid(options: KgInstallOptions) {
  if (options.HTML5Url) {
    kinggrid.config.HTML5Url = options.HTML5Url;
  }

  if (options.convert) {
    if (typeof options.convert === "string") {
      kinggrid.config.convert = async (current: PltUser) => {
        const prop = (options.convert || "username") as keyof PltUser;
        return current[prop] as string;
      };
    } else {
      kinggrid.config.convert = options.convert;
    }
  }

  if (!window.Signature) {
    window.Signature = {
      setRequestHeader(...args: any[]) {
        console.log("执行预制的 [Signature.setRequestHeader] 方法，参数：");
        console.log(...args);
      }
    };
  }

  const cssList = [
    "core/theme-color.css",
    "dialog/artDialog/ui-dialog.css",
    "core/kinggrid.plus.css",
    "css/search.css"
  ];
  const jsList = [
    "jquery-1.8.3.min.js",
    "jquery.i18n.properties.min.js",
    "core/kinggrid.min.js",
    "core/kinggrid.plus.min.js",
    "dialog/artDialog/dialog-min.js",
    "signature.min.js", // 改写了 XmlHttpRequest.proptertype.send 方法，在方法中绑定了Signature对象
    "signature.pc.min.js",
    "password.min.js",
    "signature_pad.min.js",
    "jquery.qrcode.min.js",
    "qrcode.min.js",
    "jsQR.js",
    "search.js"
  ];

  for (let i = 0; i < cssList.length; i++) {
    const cssUrl = new URL(`${kinggrid.config.kgAssetUrl}/${cssList[i]}`);
    cssUrl.searchParams.append("_t", Date.now().toString());
    await loadCss(cssUrl.toString());
  }

  for (let i = 0; i < jsList.length; i++) {
    const jsUrl = new URL(`${kinggrid.config.kgAssetUrl}/${jsList[i]}`);
    jsUrl.searchParams.append("_t", Date.now().toString());
    await loadJs(jsUrl.toString());
  }

  window.SignatureEnable = true;
}

export const install_kinggrid = _install_kinggrid;

